module.exports = __webpack_public_path__ + "img/search.fa43e7d9.svg";